import { APP_INITIALIZER, ErrorHandler, Provider } from '@angular/core';
import { Router } from '@angular/router';
import * as Sentry from '@sentry/angular';
import { environment } from '../../environments/environment';

export function initializeSentry(): void {
  if (environment.sentryDsn) {
    Sentry.init({
      dsn: environment.sentryDsn,
      sendDefaultPii: true,
      // BrowserApiErrors and Breadcrumbs patch browser event APIs and conflict with Kendo's popup click handling
      integrations: (defaults) => defaults.filter((i) => !['BrowserApiErrors', 'Breadcrumbs'].includes(i.name)),
    });
    console.log('[Sentry] Init');
  }
}

export function provideSentry(): Provider[] {
  if (!environment.sentryDsn) {
    return [];
  }

  return [
    {
      provide: ErrorHandler,
      useValue: Sentry.createErrorHandler({ logErrors: true }),
    },
    {
      provide: Sentry.TraceService,
      deps: [Router],
    },
    {
      provide: APP_INITIALIZER,
      useFactory: () => () => {},
      deps: [Sentry.TraceService],
      multi: true,
    }
  ];
}
